module.exports = __webpack_public_path__ + "img/1-3.609239e8.png";